import ratingBullets from '../utils/rating-bullets.js';

export default (productId) => ({
  reviews: [],
  showForm: false,
  currentScore: 0,
  pagination: null,
  currentPage: 1,
  sort: "postDate desc",
  rating: null,
  roundedRating: null,
  loadingReviews: false,
  loadingRatings: false,
  ratingFilter: null,
  init () {
    this.fetchReviews();
    this.$watch('sort', () => {
      this.currentPage = 1;
      this.fetchReviews();
    });
    this.$watch('ratingFilter', () => {
      this.currentPage = 1;
      this.fetchReviews();
    });
    window.addEventListener('resize', this.checkOverflow.bind(this));
  },
  submitForm () {
    fetch(this.$refs.reviewForm.getAttribute('action'), {
      method: this.$refs.reviewForm.getAttribute('method'),
      headers: {
        "Accept": "application/json",
      },
      body: new FormData(this.$refs.reviewForm)
    }).then(res => res.json())
      .then(function (data) {
        if (data.errors) {
          const msgError = document.querySelector("#msg-error");
          if(msgError) {
            msgError.classList.remove("hidden");
          }
        } else {
          const msgSuccess = document.querySelector("#msg-success");
          if(msgSuccess) {
            msgSuccess.classList.remove("hidden");
            document.querySelector("#write-review").classList.add("hidden");
            document.getElementById("review-form-container").scrollIntoView({ behavior: "smooth" });
          }
        }
      });
  },
  loadMore () {
    this.currentPage++;
    this.fetchReviews();
  },
  async fetchReviews () {
    this.loadingReviews = true;
    const lang = document.documentElement.lang.toLowerCase();
    const reviewsSource = await fetch(`/${lang}/api/reviews/${productId}?orderBy=${this.sort}&page=${this.currentPage}&rating=${this.ratingFilter ?? ''}`);
    const reviewsData = await reviewsSource.json();
    this.loadingReviews = false;
    this.pagination = reviewsData.meta.pagination;
    this.currentPage = this.pagination.current_page;

    if (this.currentPage > 1) {
      this.reviews = this.reviews.concat(
        reviewsData.data.map(review => ({
          ...review,
          showReadMore: false,
          showFullResponse: false,
        }))
      );
    } else {
      this.reviews = reviewsData.data.map(review => ({
        ...review,
        showReadMore: false,
        showFullResponse: false,
      }));
    }

    this.$nextTick(() => {
      this.imagesPopup();
      ratingBullets();
      this.checkOverflow();
    });
  },
  ratingFilterClick (rating) {
    if(rating === this.ratingFilter) {
      this.ratingFilter = null;
    } else {
      this.ratingFilter = rating;
    }
  },
  imagesPopup () {
    const imageButtons = document.querySelectorAll(".review-enlarge-img-btn");
    const imagePopup = document.querySelector("#review-img-popup");
    const enlargedImage = imagePopup.querySelector("img");
    const btnClosePopup = document.querySelector("#btn-close-img-popup");

    if(imageButtons.length > 0 && imagePopup) {
      imageButtons.forEach(button => {
        button.addEventListener("click", () => {
          imagePopup.showModal();
          document.querySelector('body').classList.add('overflow-hidden');
          let imgSrc = button.dataset.src;
          enlargedImage.src = imgSrc;
        });
      });

      btnClosePopup.addEventListener("click", () => {
        imagePopup.close();
        enlargedImage.src = "";
      });

      imagePopup.addEventListener('close', () => {
        document.querySelector('body').classList.remove('overflow-hidden');
      });
    }
  },
  checkOverflow () {
    const responseEls = document.querySelectorAll('.review-response');
    if (!responseEls) return;

    responseEls.forEach((el) => {
      const id = Number(el.dataset.reviewId);
      const review = this.reviews.find(r => r.id === id);
      if (review) {
        review.showReadMore = el.scrollHeight > el.clientHeight;
      } else {
        review.showReadMore = false;
      }
    });
  },
});
